import { InvoiceStatus } from "./Invoice";

export enum AutoPayTypes {
  AllInvoices = "ALL_INVOICES",
  AllInvoicesUpdate = "ALL_INVOICES_UPDATE"
}
export interface InvoiceDataType {
  invoiceId: string | undefined;
  dueDate: string | undefined;
  soldToOrgId: number | undefined;
  status: InvoiceStatus;
}

export enum AutomaticPaymentType {
  AutoPay = "AUTO_PAY",
  SchedulePay = "SCHEDULED_PAY"
}

export interface ScheduledPaymentDetails {
  paymentScheduleId?: string;
  invoiceId?: string;
  scheduledPaymentDate?: string;
  paymentMethodId?: string;
  paymentScheduleOption?: string;
}
